import Vue from "vue";
import Router from "vue-router";
import ListaPreMatricula from "./views/listaprematricula"
import Termos from "./views/termos"
import Main from "./views/main"

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/home",
      name: "Main",
      component: Main,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/lista",
      name: "lista",
      component: ListaPreMatricula
    },
    {
      path: "/termos",
      name: "termos",
      component: Termos
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "*",
      redirect: "/home"
    },
  ]
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js